// 宮崎県の歴史に関する四択問題100問 - 10問1セット×10セット

export const quizSets = [
  {
    id: 1,
    title: "セット1: 神話と古代の礎",
    category: "神話・古代",
    questions: [
      {
        id: 1,
        question: "日本神話において、天照大神が弟スサノオノミコトの乱暴に怒り、隠れたとされる洞窟の名前は何ですか？",
        options: [
          "天安河原",
          "天岩戸",
          "槵觸の峰",
          "高千穂峡"
        ],
        correctAnswer: 1,
        explanation: "天照大神が隠れたとされる洞窟は「天岩戸」です。この神話は宮崎県高千穂町の天岩戸神社に伝わっています。"
      },
      {
        id: 2,
        question: "天照大神が天岩戸に隠れた際、八百万の神々が集まって対策を協議した場所はどこですか？",
        options: [
          "青島",
          "鵜戸神宮",
          "天安河原",
          "皇子原"
        ],
        correctAnswer: 2,
        explanation: "天安河原は、八百万の神々が集まって対策を協議した場所とされています。現在も多くの人が訪れるパワースポットです。"
      },
      {
        id: 3,
        question: "天岩戸神話で、岩戸を少し開けた天照大神を外に連れ出した力自慢の神は誰ですか？",
        options: [
          "瓊々杵尊",
          "猿田彦大神",
          "手力雄命",
          "武甕槌神"
        ],
        correctAnswer: 2,
        explanation: "手力雄命（たぢからおのみこと）は、天岩戸を引き開けた力の神として知られています。"
      },
      {
        id: 4,
        question: "天岩戸と呼ばれる洞窟を御神体として祀っている神社はどこですか？",
        options: [
          "高千穂神社",
          "天岩戸神社",
          "槵觸神社",
          "青島神社"
        ],
        correctAnswer: 1,
        explanation: "天岩戸神社は、天岩戸と呼ばれる洞窟を御神体として祀っています。"
      },
      {
        id: 5,
        question: "天照大神の孫であり、葦原中国を治めるために高天原から降臨した神は誰ですか？",
        options: [
          "神武天皇",
          "山幸彦",
          "瓊々杵尊",
          "海幸彦"
        ],
        correctAnswer: 2,
        explanation: "瓊々杵尊（ににぎのみこと）は、天照大神の孫として天孫降臨した神です。"
      },
      {
        id: 6,
        question: "瓊々杵尊が天孫降臨したとされる場所として、『古事記』に記されている峰はどこですか？",
        options: [
          "高千穂峰",
          "二上山",
          "くしふる峰",
          "霧島山"
        ],
        correctAnswer: 2,
        explanation: "『古事記』には、瓊々杵尊が「くしふる峰」に降臨したと記されています。"
      },
      {
        id: 7,
        question: "天孫降臨の際、瓊々杵尊一行の道案内をした地上の神は誰ですか？",
        options: [
          "塩筒大神",
          "猿田彦大神",
          "大国主命",
          "武甕槌神"
        ],
        correctAnswer: 1,
        explanation: "猿田彦大神（さるたひこのおおかみ）は、天孫降臨の際に道案内を務めた神として知られています。"
      },
      {
        id: 8,
        question: "天孫降臨の地とされる「くしふる峰」を御神体として祀り、元禄7年（1694年）に社殿が建立された神社は何ですか？",
        options: [
          "二上神社",
          "荒立神社",
          "高千穂神社",
          "槵觸神社"
        ],
        correctAnswer: 3,
        explanation: "槵觸神社（くしふるじんじゃ）は、「くしふる峰」を御神体として祀る神社です。"
      },
      {
        id: 9,
        question: "天孫降臨の際、地上に水がなかったため、天村雲命が天から水種を移したと伝えられる場所はどこですか？",
        options: [
          "真名井の滝",
          "天真名井",
          "御池",
          "五ヶ瀬川"
        ],
        correctAnswer: 1,
        explanation: "天真名井（あめのまない）は、天村雲命が天から水種を移したとされる場所です。"
      },
      {
        id: 10,
        question: "霧島山系の高千穂峰山頂にあり、瓊々杵尊が降臨の際に突き立てたとされる社宝は何ですか？",
        options: [
          "三種の神器",
          "天逆鉾",
          "鎮め石",
          "鉄造狛犬"
        ],
        correctAnswer: 1,
        explanation: "天逆鉾（あまのさかほこ）は、高千穂峰の山頂に突き立てられている伝説の鉾です。"
      }
    ]
  },
  {
    id: 2,
    title: "セット2: 神話と古代の礎（海幸彦・山幸彦）",
    category: "神話・古代",
    questions: [
      {
        id: 11,
        question: "海で漁をして暮らしていた兄・海幸彦の正式な神名は何ですか？",
        options: [
          "彦火々出見命",
          "火照命",
          "鵜葺草葺不合命",
          "磐余彦尊"
        ],
        correctAnswer: 1,
        explanation: "海幸彦の正式な神名は「火照命（ほでりのみこと）」です。"
      },
      {
        id: 12,
        question: "兄の釣り針を失くした山幸彦が、海の神の宮殿へ行くよう助言した神は誰ですか？",
        options: [
          "猿田彦大神",
          "塩筒大神",
          "住吉三神",
          "大山津見神"
        ],
        correctAnswer: 1,
        explanation: "塩筒大神（しおつつのおおかみ）が、山幸彦に海神の宮殿へ行くよう助言しました。"
      },
      {
        id: 13,
        question: "山幸彦が海の神の宮殿で出会い、結婚した海の神の娘は誰ですか？",
        options: [
          "木花咲耶姫",
          "玉依姫",
          "豊玉姫",
          "須勢理毘売"
        ],
        correctAnswer: 2,
        explanation: "豊玉姫（とよたまひめ）は、山幸彦が海神の宮殿で出会い結婚した海神の娘です。"
      },
      {
        id: 14,
        question: "山幸彦が海の神から授かり、兄・海幸彦を降参させるために用いた2つの玉は何ですか？",
        options: [
          "勾玉と管玉",
          "陰陽珠",
          "塩盈珠と塩乾珠",
          "生魂と足魂"
        ],
        correctAnswer: 2,
        explanation: "塩盈珠（しおみつたま）と塩乾珠（しおひるたま）は、潮の満ち引きを操る力を持つ2つの玉です。"
      },
      {
        id: 15,
        question: "豊玉姫が出産する際に本来の姿を見られてしまい、我が子のために乳房を岩に残したとされる伝説が伝わる神社はどこですか？",
        options: [
          "青島神社",
          "鵜戸神宮",
          "潮嶽神社",
          "宮崎神宮"
        ],
        correctAnswer: 1,
        explanation: "鵜戸神宮（うどじんぐう）には、豊玉姫が乳房を岩に残したという伝説が伝わっています。"
      },
      {
        id: 16,
        question: "鵜戸神宮の洞窟内にあり、母乳の出が良くなると信仰されている「お乳あめ」の元となった岩の名前は何ですか？",
        options: [
          "産婆石",
          "亀石",
          "お乳岩",
          "腰かけ岩"
        ],
        correctAnswer: 2,
        explanation: "お乳岩は、母乳の出が良くなると信仰されており、「お乳あめ」の元となった岩です。"
      },
      {
        id: 17,
        question: "全国で唯一、兄・海幸彦を主祭神として祀っている神社はどこですか？",
        options: [
          "野島神社",
          "串間神社",
          "潮嶽神社",
          "江田神社"
        ],
        correctAnswer: 2,
        explanation: "潮嶽神社（うしおだけじんじゃ）は、全国で唯一、海幸彦を主祭神として祀っています。"
      },
      {
        id: 18,
        question: "初代天皇とされる神武天皇の幼名は何ですか？",
        options: [
          "狭野尊",
          "磐余彦尊",
          "彦火々出見命",
          "御毛沼命"
        ],
        correctAnswer: 0,
        explanation: "神武天皇の幼名は「狭野尊（さののみこと）」です。"
      },
      {
        id: 19,
        question: "神武天皇の生誕地とされ、産屋があった跡に建てられたと伝わる高原町の神社はどこですか？",
        options: [
          "狭野神社",
          "霧島東神社",
          "皇子原神社",
          "宮崎神宮"
        ],
        correctAnswer: 2,
        explanation: "皇子原神社（おうじばるじんじゃ）は、神武天皇の産屋があった跡に建てられたとされる神社です。"
      },
      {
        id: 20,
        question: "神武天皇が東征に出発するまでの約30年間を過ごしたとされる皇居跡「皇宮屋」に建てられた、宮崎神宮の摂社は何ですか？",
        options: [
          "江田神社",
          "皇宮神社",
          "五所稲荷神社",
          "立磐神社"
        ],
        correctAnswer: 1,
        explanation: "皇宮神社（こうぐうじんじゃ）は、神武天皇が過ごした皇居跡に建てられた摂社です。"
      }
    ]
  },
  {
    id: 3,
    title: "セット3: 神話と古代の礎（神武東征・古墳）",
    category: "神話・古代",
    questions: [
      {
        id: 21,
        question: "神武天皇が東征の際に船出したと伝えられる港は、現在の日向市のどこですか？",
        options: [
          "細島港",
          "油津港",
          "美々津",
          "宮崎港"
        ],
        correctAnswer: 2,
        explanation: "美々津（みみつ）は、神武天皇が東征の際に船出したと伝えられる港です。"
      },
      {
        id: 22,
        question: "西都原古墳群に現存する古墳の総数は約何基ですか？",
        options: [
          "約120基",
          "約220基",
          "約320基",
          "約420基"
        ],
        correctAnswer: 2,
        explanation: "西都原古墳群には、約320基の古墳が現存しています。"
      },
      {
        id: 23,
        question: "西都原古墳群で最大の前方後円墳であり、瓊々杵尊の妃コノハナサクヤヒメの陵墓参考地とされているのはどれですか？",
        options: [
          "男狭穂塚",
          "女狭穂塚",
          "鬼の窟古墳",
          "姫塚"
        ],
        correctAnswer: 1,
        explanation: "女狭穂塚（めさほづか）は、西都原古墳群で最大の前方後円墳で、コノハナサクヤヒメの陵墓参考地とされています。"
      },
      {
        id: 24,
        question: "西都原古墳群で唯一、横穴式石室を持つ円墳で、鬼が一夜で造ったという伝説が残る古墳は何ですか？",
        options: [
          "13号墳",
          "171号墳",
          "202号墳",
          "鬼の窟古墳"
        ],
        correctAnswer: 3,
        explanation: "鬼の窟古墳（おにのいわやこふん）は、鬼が一夜で造ったという伝説が残る古墳です。"
      },
      {
        id: 25,
        question: "日本で初めて本格的な学術調査が行われた古墳群として知られる西都原古墳群の調査が開始されたのはいつですか？",
        options: [
          "明治元年（1868年）",
          "大正元年（1912年）",
          "昭和元年（1926年）",
          "昭和41年（1966年）"
        ],
        correctAnswer: 1,
        explanation: "西都原古墳群の本格的な学術調査は、大正元年（1912年）に開始されました。"
      },
      {
        id: 26,
        question: "日向国南部、特に飫肥城をめぐり、戦国時代に約100年間にわたって争った2つの氏族は誰と誰ですか？",
        options: [
          "土持氏と島津氏",
          "伊東氏と大友氏",
          "伊東氏と島津氏",
          "秋月氏と相良氏"
        ],
        correctAnswer: 2,
        explanation: "伊東氏と島津氏が、飫肥城をめぐり約100年間にわたって争いました。"
      },
      {
        id: 27,
        question: "伊東氏の最盛期を築き上げ、「伊東四十八城」と称される支配体制を確立した武将は誰ですか？",
        options: [
          "伊東祐兵",
          "伊東義祐",
          "伊東祐国",
          "伊東尹祐"
        ],
        correctAnswer: 1,
        explanation: "伊東義祐（いとうよしすけ）は、「伊東四十八城」と称される支配体制を確立しました。"
      },
      {
        id: 28,
        question: "元亀3年（1572年）、伊東軍3,000に対し島津軍300という兵力差で島津義弘が勝利し、「九州の桶狭間」と称される戦いは何ですか？",
        options: [
          "耳川の戦い",
          "沖田畷の戦い",
          "木崎原の戦い",
          "戸次川の戦い"
        ],
        correctAnswer: 2,
        explanation: "木崎原の戦い（きざきばるのたたかい）は、「九州の桶狭間」と称される劇的な戦いでした。"
      },
      {
        id: 29,
        question: "木崎原の戦いで、島津義弘が用いたとされる、囮部隊で敵を誘い込み、伏兵で包囲撃滅する得意戦法は何ですか？",
        options: [
          "鶴翼の陣",
          "魚鱗の陣",
          "釣り野伏せ",
          "車懸りの陣"
        ],
        correctAnswer: 2,
        explanation: "釣り野伏せ（つりのぶせ）は、島津氏が得意とした戦法で、囮と伏兵を組み合わせたものです。"
      },
      {
        id: 30,
        question: "木崎原の戦いの後、家臣の離反が相次ぎ勢力を失った伊東義祐が、豊後国を頼って日向から逃亡した出来事を何と呼びますか？",
        options: [
          "伊東崩れ",
          "高城川の戦い",
          "九州平定",
          "飫肥役"
        ],
        correctAnswer: 0,
        explanation: "伊東崩れ（いとうくずれ）は、伊東義祐が豊後国へ逃亡した出来事を指します。"
      }
    ]
  },
  {
    id: 4,
    title: "セット4: 武士の時代",
    category: "戦国時代",
    questions: [
      {
        id: 31,
        question: "天正6年（1578年）、伊東氏を支援する大友宗麟軍と島津義久軍が日向国で激突した大規模な合戦は何ですか？",
        options: [
          "庄内の乱",
          "木崎原の戦い",
          "根白坂の戦い",
          "耳川の戦い"
        ],
        correctAnswer: 3,
        explanation: "耳川の戦い（みみかわのたたかい）は、大友氏と島津氏が激突した大規模な合戦でした。"
      },
      {
        id: 32,
        question: "耳川の戦いの主戦場となったのは、現在の宮崎県木城町を流れる何の川の周辺ですか？",
        options: [
          "五ヶ瀬川",
          "大淀川",
          "高城川（小丸川）",
          "耳川"
        ],
        correctAnswer: 2,
        explanation: "高城川（小丸川）の周辺が、耳川の戦いの主戦場となりました。"
      },
      {
        id: 33,
        question: "耳川の戦いで大友軍が包囲した、山田有信らが守る島津方の城は何城ですか？",
        options: [
          "佐土原城",
          "都於郡城",
          "高城",
          "縣城"
        ],
        correctAnswer: 2,
        explanation: "高城（たかじょう）は、山田有信らが守る島津方の城でした。"
      },
      {
        id: 34,
        question: "耳川の戦いで大友軍が敗北した要因の一つとして、キリスト教に傾倒した大友宗麟が日向で行った何が家臣団の反発を招いたとされていますか？",
        options: [
          "楽市楽座の導入",
          "寺社仏閣の破壊",
          "新たな検地の実施",
          "南蛮貿易の禁止"
        ],
        correctAnswer: 1,
        explanation: "大友宗麟による寺社仏閣の破壊が、家臣団の反発を招いたとされています。"
      },
      {
        id: 35,
        question: "耳川の戦いの勝利により、薩摩・大隅・日向の三州をほぼ手中に収め、「三州の太守」となった島津氏の当主は誰ですか？",
        options: [
          "島津貴久",
          "島津義弘",
          "島津義久",
          "島津家久"
        ],
        correctAnswer: 2,
        explanation: "島津義久（しまづよしひさ）は、耳川の戦いの勝利により「三州の太守」となりました。"
      },
      {
        id: 36,
        question: "九州統一を目指す島津氏に対し、豊臣秀吉が天下統一事業の一環として行った軍事行動は何ですか？",
        options: [
          "文禄・慶長の役",
          "小田原征伐",
          "九州平定",
          "四国平定"
        ],
        correctAnswer: 2,
        explanation: "豊臣秀吉による九州平定（きゅうしゅうへいてい）は、島津氏を服属させた軍事行動です。"
      },
      {
        id: 37,
        question: "豊臣秀吉の九州平定において、かつて日向を追われた伊東祐兵は、秀吉軍の中でどのような役割を果たしましたか？",
        options: [
          "兵糧の輸送役",
          "鉄砲隊の指揮官",
          "先導役",
          "和平交渉の使者"
        ],
        correctAnswer: 2,
        explanation: "伊東祐兵（いとうすけたけ）は、地理に詳しいため先導役を務めました。"
      },
      {
        id: 38,
        question: "九州平定における日向での決戦となり、豊臣軍が島津軍に勝利した戦いはどこで行われましたか？",
        options: [
          "根白坂",
          "木崎原",
          "高城川原",
          "穆佐城"
        ],
        correctAnswer: 0,
        explanation: "根白坂（ねじろざか）の戦いが、日向での決戦となりました。"
      },
      {
        id: 39,
        question: "九州平定後、豊臣秀吉からその功績を認められ、伊東祐兵が旧領として与えられたのはどこですか？",
        options: [
          "佐土原",
          "縣（延岡）",
          "飫肥",
          "都於郡"
        ],
        correctAnswer: 2,
        explanation: "伊東祐兵は、旧領の飫肥（おび）を与えられました。"
      },
      {
        id: 40,
        question: "関ヶ原の戦いにおいて、大坂にいた伊東祐兵は重病のため出陣できませんでしたが、密かにどちらの軍に味方する意思を示しましたか？",
        options: [
          "西軍（石田三成方）",
          "東軍（徳川家康方）",
          "中立を保った",
          "豊臣家を守るため大坂城に籠城した"
        ],
        correctAnswer: 1,
        explanation: "伊東祐兵は、密かに東軍（徳川家康方）に味方する意思を示しました。"
      }
    ]
  },
  {
    id: 5,
    title: "セット5: 武士の時代（関ヶ原以降）",
    category: "戦国時代",
    questions: [
      {
        id: 41,
        question: "関ヶ原の戦いの際、国元に残った飫肥藩の家臣団が攻撃した、高橋元種が治める城はどこですか？",
        options: [
          "延岡城",
          "佐土原城",
          "宮崎城",
          "穆佐城"
        ],
        correctAnswer: 0,
        explanation: "飫肥藩の家臣団は、延岡城を攻撃しました。"
      },
      {
        id: 42,
        question: "豊臣秀吉の九州平定後、日向国は分割されましたが、島津氏が安堵されたのはどの地域ですか？",
        options: [
          "臼杵郡",
          "児湯郡",
          "宮崎郡",
          "諸県郡"
        ],
        correctAnswer: 3,
        explanation: "島津氏は、諸県郡（もろかたぐん）を安堵されました。"
      },
      {
        id: 43,
        question: "鎌倉時代に日向国の地頭職を拝領し、のちに日向に移り住んで戦国大名へと発展した伊東氏の祖は、誰の子孫とされていますか？",
        options: [
          "源頼朝",
          "足利尊氏",
          "北条時政",
          "工藤祐経"
        ],
        correctAnswer: 3,
        explanation: "伊東氏の祖は、工藤祐経（くどうすけつね）の子孫とされています。"
      },
      {
        id: 44,
        question: "耳川の戦いの後、九州の勢力図は大きく変化しました。島津氏、大友氏と並び、肥前で勢力を拡大した氏族は誰ですか？",
        options: [
          "龍造寺氏",
          "相良氏",
          "秋月氏",
          "鍋島氏"
        ],
        correctAnswer: 0,
        explanation: "龍造寺氏（りゅうぞうじし）が、肥前で勢力を拡大しました。"
      },
      {
        id: 45,
        question: "木崎原の戦いで戦死した伊東軍の将兵と、壮絶な戦いを繰り広げた島津軍の将兵を敵味方なく供養するために、島津義弘が建立したものは何ですか？",
        options: [
          "伊東塚",
          "太刀洗いの池",
          "六地蔵塔",
          "宗麟原供養塔"
        ],
        correctAnswer: 2,
        explanation: "島津義弘は、敵味方なく供養するために六地蔵塔を建立しました。"
      },
      {
        id: 46,
        question: "江戸時代、日向国南部を治めた飫肥藩の藩主として、幕末まで存続した氏族は何ですか？",
        options: [
          "島津氏",
          "秋月氏",
          "内藤氏",
          "伊東氏"
        ],
        correctAnswer: 3,
        explanation: "伊東氏が、飫肥藩の藩主として幕末まで存続しました。"
      },
      {
        id: 47,
        question: "飫肥藩は山がちで耕地が少なかったため、藩の財政を支える主要な産業として何を奨励しましたか？",
        options: [
          "焼酎の醸造",
          "飫肥杉の植林",
          "陶磁器の生産",
          "沿岸漁業"
        ],
        correctAnswer: 1,
        explanation: "飫肥藩は、飫肥杉（おびすぎ）の植林を奨励しました。"
      },
      {
        id: 48,
        question: "飫肥杉が木造船の材料として重用された理由として、適切でないものは次のうちどれですか？",
        options: [
          "樹脂を多く含み腐りにくい",
          "密度が高く非常に硬い",
          "軽量で強度が高い",
          "弾力性があり曲げに強い"
        ],
        correctAnswer: 1,
        explanation: "飫肥杉は密度が高く硬いわけではありませんが、他の特性により造船用材料として重宝されました。"
      },
      {
        id: 49,
        question: "飫肥藩が専売品として生産し、特に造船用に加工された飫肥杉の木材は何と呼ばれましたか？",
        options: [
          "弁甲材",
          "柾目材",
          "樽丸材",
          "床柱材"
        ],
        correctAnswer: 0,
        explanation: "弁甲材（べんこうざい）は、造船用に加工された飫肥杉の木材です。"
      },
      {
        id: 50,
        question: "江戸時代、日向国北部を治めた高鍋藩の藩主だった氏族は何ですか？",
        options: [
          "有馬氏",
          "伊東氏",
          "秋月氏",
          "牧野氏"
        ],
        correctAnswer: 2,
        explanation: "秋月氏（あきづきし）が、高鍋藩の藩主でした。"
      }
    ]
  },
  {
    id: 6,
    title: "セット6: 江戸時代の統治と文化",
    category: "江戸時代",
    questions: [
      {
        id: 51,
        question: "高鍋藩の第7代藩主で、藩校「明倫堂」を設立し、名君として知られる人物は誰ですか？",
        options: [
          "秋月種実",
          "秋月種長",
          "秋月種茂",
          "秋月種樹"
        ],
        correctAnswer: 2,
        explanation: "秋月種茂（あきづきたねしげ）は、藩校「明倫堂」を設立した名君として知られています。"
      },
      {
        id: 52,
        question: "高鍋藩の藩校「明倫堂」が、他の多くの藩校と異なっていた特筆すべき教育方針は何ですか？",
        options: [
          "洋学を専門に教えた",
          "藩士だけでなく一般庶民の入学も許可した",
          "女子の入学を認めた",
          "授業料を完全に無料化した"
        ],
        correctAnswer: 1,
        explanation: "明倫堂は、藩士だけでなく一般庶民の入学も許可した画期的な藩校でした。"
      },
      {
        id: 53,
        question: "高鍋藩主・秋月種茂の実弟で、米沢藩上杉家の養子となり、藩政改革を断行したことで有名な人物は誰ですか？",
        options: [
          "細川重賢",
          "上杉鷹山",
          "徳川宗春",
          "松平定信"
        ],
        correctAnswer: 1,
        explanation: "上杉鷹山（うえすぎようざん）は、秋月種茂の実弟で、米沢藩の藩政改革で有名です。"
      },
      {
        id: 54,
        question: "秋月種茂が高鍋藩で実施した、農家の3人目以降の子どもに米や麦を支給する制度は、現代の何に相当すると言われていますか？",
        options: [
          "義務教育制度",
          "年金制度",
          "児童手当制度",
          "医療保険制度"
        ],
        correctAnswer: 2,
        explanation: "この制度は、現代の児童手当制度に相当すると言われています。"
      },
      {
        id: 55,
        question: "江戸時代、日向国北部の延岡藩は藩主家が度々交代しました。元禄4年（1691年）に農民の逃散事件が原因で越後糸魚川へ転封となった氏族は何ですか？",
        options: [
          "内藤氏",
          "有馬氏",
          "三浦氏",
          "牧野氏"
        ],
        correctAnswer: 1,
        explanation: "有馬氏（ありまし）が、農民の逃散事件が原因で転封となりました。"
      },
      {
        id: 56,
        question: "延享4年（1747年）に延岡藩主となり、以後明治維新まで123年間にわたって同地を治めた氏族は何ですか？",
        options: [
          "牧野氏",
          "秋月氏",
          "内藤氏",
          "高橋氏"
        ],
        correctAnswer: 2,
        explanation: "内藤氏（ないとうし）が、延享4年から明治維新まで延岡を治めました。"
      },
      {
        id: 57,
        question: "飫肥藩清武郷出身で、江戸時代後期を代表する儒学者となり、幕府の儒官も務めた人物は誰ですか？",
        options: [
          "平部嶠南",
          "安井滄洲",
          "安井息軒",
          "落合雙石"
        ],
        correctAnswer: 2,
        explanation: "安井息軒（やすいそっけん）は、江戸時代後期を代表する儒学者です。"
      },
      {
        id: 58,
        question: "安井息軒が江戸で開いた私塾「三計塾」の名前の由来となった「三計の教え」に含まれないものは次のうちどれですか？",
        options: [
          "一日の計は朝にあり",
          "一年の計は春にあり",
          "一生の計は少壮の時にあり",
          "一国の計は民にあり"
        ],
        correctAnswer: 3,
        explanation: "「一国の計は民にあり」は、三計の教えには含まれていません。"
      },
      {
        id: 59,
        question: "安井息軒が江戸にありながら故郷の飫肥藩に貢献した事績として、適切でないものはどれですか？",
        options: [
          "「間引き」の禁止を進言した",
          "天然痘予防のための種痘法を広めた",
          "藩校「振徳堂」を創設した",
          "養蚕業を奨励した"
        ],
        correctAnswer: 2,
        explanation: "藩校「振徳堂」は、息軒以前から存在していました。"
      },
      {
        id: 60,
        question: "高鍋藩の教育水準の高さを表す言葉として、近隣諸藩で言われていたのは次のうちどれですか？",
        options: [
          "「高鍋の武士は文武両道」",
          "「高鍋で学者ぶるな」",
          "「高鍋に学問の風が吹く」",
          "「高鍋の民は読み書きができる」"
        ],
        correctAnswer: 1,
        explanation: "「高鍋で学者ぶるな」という言葉は、高鍋藩の教育水準の高さを示しています。"
      }
    ]
  },
  {
    id: 7,
    title: "セット7: 江戸時代の統治と文化（教育・文化）",
    category: "江戸時代",
    questions: [
      {
        id: 61,
        question: "飫肥藩の藩校の名前は何ですか？",
        options: [
          "明倫堂",
          "振徳堂",
          "造士館",
          "時習館"
        ],
        correctAnswer: 1,
        explanation: "飫肥藩の藩校は「振徳堂（しんとくどう）」です。"
      },
      {
        id: 62,
        question: "高鍋藩校「明倫堂」の卒業生で、初代大審院検事総長を務めるなど、近代日本の法曹界の礎を築いた人物は誰ですか？",
        options: [
          "石井十次",
          "秋月左都夫",
          "三好退蔵",
          "鈴木馬左也"
        ],
        correctAnswer: 2,
        explanation: "三好退蔵（みよしたいぞう）は、初代大審院検事総長を務めました。"
      },
      {
        id: 63,
        question: "安井息軒が学んだ江戸幕府直轄の学問所は何ですか？",
        options: [
          "咸宜園",
          "昌平坂学問所",
          "適塾",
          "鳴滝塾"
        ],
        correctAnswer: 1,
        explanation: "昌平坂学問所（しょうへいざかがくもんじょ）は、江戸幕府直轄の学問所でした。"
      },
      {
        id: 64,
        question: "延岡藩主であった有馬康純の代に行われた延岡城の大修築で建設されたものの、火災で焼失し再建されなかった建物は何ですか？",
        options: [
          "天守閣",
          "本丸御殿",
          "三階櫓",
          "北大手門"
        ],
        correctAnswer: 2,
        explanation: "三階櫓（さんかいやぐら）は、火災で焼失し再建されませんでした。"
      },
      {
        id: 65,
        question: "飫肥藩で代々伊東家に仕え、その刀は「大阪政宗」とも称された名工は誰ですか？",
        options: [
          "井上真改",
          "源清麿",
          "堀川国広",
          "国綱"
        ],
        correctAnswer: 3,
        explanation: "国綱（くにつな）は、「大阪政宗」とも称された名工でした。"
      },
      {
        id: 66,
        question: "1877年（明治10年）の西南戦争において、宮崎県が最後の組織的な決戦の場となりました。延岡近郊で行われたこの戦いは何ですか？",
        options: [
          "田原坂の戦い",
          "城山の戦い",
          "和田越の戦い",
          "高城の戦い"
        ],
        correctAnswer: 2,
        explanation: "和田越の戦い（わだごえのたたかい）は、西南戦争最後の組織的な決戦でした。"
      },
      {
        id: 67,
        question: "西南戦争の際、西郷隆盛率いる薩摩軍に参加した旧延岡藩士たちで組織された部隊の名前は何ですか？",
        options: [
          "薩摩隊",
          "飫肥隊",
          "延岡隊",
          "日向隊"
        ],
        correctAnswer: 2,
        explanation: "延岡隊（のべおかたい）は、旧延岡藩士たちで組織された部隊です。"
      },
      {
        id: 68,
        question: "和田越の戦いで敗れた西郷隆盛が、陸軍大将の軍服を焼き、軍の解散を布告したとされる場所は、延岡市のどこですか？",
        options: [
          "延岡城下",
          "北川町俵野",
          "北方町",
          "祝子川"
        ],
        correctAnswer: 1,
        explanation: "北川町俵野（きたがわちょうたわらの）で、西郷隆盛は軍の解散を布告しました。"
      },
      {
        id: 69,
        question: "軍解散後、西郷隆盛が少数の兵と共に政府軍の包囲網を突破した山は何ですか？",
        options: [
          "霧島山",
          "祖母山",
          "可愛岳",
          "市房山"
        ],
        correctAnswer: 2,
        explanation: "可愛岳（えのだけ）を突破して、西郷隆盛は鹿児島へ向かいました。"
      },
      {
        id: 70,
        question: "飫肥藩出身の外交官で、日英同盟の締結やポーツマス条約の調印に尽力した人物は誰ですか？",
        options: [
          "高木兼寛",
          "川越進",
          "小村寿太郎",
          "石井十次"
        ],
        correctAnswer: 2,
        explanation: "小村寿太郎（こむらじゅたろう）は、日英同盟の締結やポーツマス条約の調印に尽力しました。"
      }
    ]
  },
  {
    id: 8,
    title: "セット8: 近代への道",
    category: "近代",
    questions: [
      {
        id: 71,
        question: "1902年（明治35年）、日本の国際的地位を大きく向上させた、小村寿太郎が外務大臣として締結した同盟は何ですか？",
        options: [
          "日独伊三国同盟",
          "日英同盟",
          "日仏協商",
          "日露協約"
        ],
        correctAnswer: 1,
        explanation: "日英同盟（にちえいどうめい）は、日本の国際的地位を大きく向上させました。"
      },
      {
        id: 72,
        question: "日露戦争の講和条約であるポーツマス条約で賠償金が獲得できなかったことに不満を抱いた民衆が、東京で起こした暴動事件は何ですか？",
        options: [
          "米騒動",
          "血盟団事件",
          "日比谷焼討事件",
          "大津事件"
        ],
        correctAnswer: 2,
        explanation: "日比谷焼討事件（ひびややきうちじけん）は、賠償金が得られなかったことへの不満から起きました。"
      },
      {
        id: 73,
        question: "小村寿太郎が第二次桂内閣の外務大臣として1911年（明治44年）に達成した、幕末以来の不平等条約改正の総仕上げとなった外交上の成果は何ですか？",
        options: [
          "領事裁判権の撤廃",
          "関税自主権の完全回復",
          "遼東半島の返還",
          "樺太全土の領有"
        ],
        correctAnswer: 1,
        explanation: "関税自主権の完全回復は、不平等条約改正の総仕上げとなりました。"
      },
      {
        id: 74,
        question: "宮崎県出身の海軍軍医で、食事改善によって海軍の脚気を根絶したことで知られる人物は誰ですか？",
        options: [
          "森鷗外",
          "高木兼寛",
          "北里柴三郎",
          "野口英世"
        ],
        correctAnswer: 1,
        explanation: "高木兼寛（たかきかねひろ）は、食事改善によって海軍の脚気を根絶しました。"
      },
      {
        id: 75,
        question: "高木兼寛が脚気の原因を栄養欠陥と仮定し、その仮説を証明するために行った比較実験で用いられた2隻の軍艦の名前は何ですか？",
        options: [
          "「金剛」と「比叡」",
          "「三笠」と「朝日」",
          "「龍驤」と「筑波」",
          "「扶桑」と「八島」"
        ],
        correctAnswer: 2,
        explanation: "「龍驤」と「筑波」の2隻の軍艦を用いて、比較実験を行いました。"
      },
      {
        id: 76,
        question: "高木兼寛が海軍の兵食改革で導入し、脚気の激減に大きな効果を上げた主食は何ですか？",
        options: [
          "玄米",
          "パン",
          "麦飯",
          "七分づき米"
        ],
        correctAnswer: 2,
        explanation: "麦飯の導入により、海軍の脚気が激減しました。"
      },
      {
        id: 77,
        question: "日向市東郷町出身の歌人で、「幾山河越えさり行かば寂しさの終てなむ国ぞ今日も旅ゆく」などの歌で知られるのは誰ですか？",
        options: [
          "斎藤茂吉",
          "石川啄木",
          "若山牧水",
          "正岡子規"
        ],
        correctAnswer: 2,
        explanation: "若山牧水（わかやまぼくすい）は、旅を詠んだ歌で知られる歌人です。"
      },
      {
        id: 78,
        question: "若山牧水の代表作とされ、その名声を高めた第3歌集のタイトルは何ですか？",
        options: [
          "『海の声』",
          "『別離』",
          "『みなかみ』",
          "『くろ土』"
        ],
        correctAnswer: 1,
        explanation: "『別離』（べつり）は、若山牧水の代表的な第3歌集です。"
      },
      {
        id: 79,
        question: "1960年代に宮崎県が「新婚旅行のメッカ」となるきっかけを作った、当時新婚旅行で宮崎を訪れた皇族はどなたですか？",
        options: [
          "皇太子夫妻（現上皇ご夫妻）",
          "常陸宮夫妻",
          "三笠宮夫妻",
          "島津貴子さん（昭和天皇第五皇女）"
        ],
        correctAnswer: 3,
        explanation: "島津貴子さん（昭和天皇第五皇女）の新婚旅行が、宮崎のハネムーンブームのきっかけとなりました。"
      },
      {
        id: 80,
        question: "宮崎のハネムーンブームを仕掛け、日南海岸へのフェニックス植栽や観光施設開発を進めた宮崎交通の経営者は誰ですか？",
        options: [
          "小村寿太郎",
          "岩切章太郎",
          "安井息軒",
          "川越進"
        ],
        correctAnswer: 1,
        explanation: "岩切章太郎（いわきりしょうたろう）は、宮崎の観光開発を推進しました。"
      }
    ]
  },
  {
    id: 9,
    title: "セット9: 近代への道（観光・スポーツ）",
    category: "近代",
    questions: [
      {
        id: 81,
        question: "1980年代のバブル期に計画され、宮崎市に建設された巨大リゾート施設は何ですか？",
        options: [
          "ハウステンボス",
          "フェニックス・シーガイア・リゾート",
          "ラグーナ蒲郡",
          "ルスツリゾート"
        ],
        correctAnswer: 1,
        explanation: "フェニックス・シーガイア・リゾートは、1980年代のバブル期に計画された巨大リゾート施設です。"
      },
      {
        id: 82,
        question: "フェニックス・シーガイア・リゾートの中核施設で、開閉式の屋根を持つ世界最大の屋内プールとしてギネスブックにも登録された施設は何ですか？",
        options: [
          "ワールドバザール",
          "オーシャンドーム",
          "アクアリーナ",
          "スパワールド"
        ],
        correctAnswer: 1,
        explanation: "オーシャンドームは、世界最大の屋内プールとしてギネスブックに登録されました。"
      },
      {
        id: 83,
        question: "2001年に経営破綻したフェニックス・シーガイア・リゾートのオーシャンドームは、その後どうなりましたか？",
        options: [
          "温泉施設としてリニューアルされた",
          "2007年に閉鎖され、後に解体された",
          "植物園に改装された",
          "現在もプールとして営業している"
        ],
        correctAnswer: 1,
        explanation: "オーシャンドームは、2007年に閉鎖され、後に解体されました。"
      },
      {
        id: 84,
        question: "宮崎県がプロ野球の春季キャンプ地として定着するきっかけとなった読売巨人軍が、初めて宮崎県でキャンプを行ったのはいつですか？",
        options: [
          "1949年",
          "1959年",
          "1969年",
          "1979年"
        ],
        correctAnswer: 1,
        explanation: "読売巨人軍は、1959年に初めて宮崎県でキャンプを行いました。"
      },
      {
        id: 85,
        question: "読売巨人軍が1959年に本格的な宮崎キャンプを開始する以前、1955年に若手中心のキャンプを行った宮崎県内の市はどこですか？",
        options: [
          "日南市",
          "串間市",
          "都城市",
          "西都市"
        ],
        correctAnswer: 1,
        explanation: "読売巨人軍は、1955年に串間市で若手中心のキャンプを行いました。"
      },
      {
        id: 86,
        question: "明治時代初期、一度は鹿児島県に併合された宮崎県が、再置（分県）されるために尽力し、「宮崎県の父」と呼ばれる人物は誰ですか？",
        options: [
          "平部嶠南",
          "川越進",
          "高木兼寛",
          "三好退蔵"
        ],
        correctAnswer: 1,
        explanation: "川越進（かわごえすすむ）は、宮崎県の再置に尽力し、「宮崎県の父」と呼ばれています。"
      },
      {
        id: 87,
        question: "高木兼寛が提唱した「病気を診ずして病人を診よ」という言葉が示す医療の精神として、最も適切なものはどれですか？",
        options: [
          "最新の医療機器を用いた診断を優先する",
          "病気の症状だけでなく、患者全体の心身の状態を診察する",
          "伝染病の撲滅を最優先課題とする",
          "栄養学よりも細菌学を重視する"
        ],
        correctAnswer: 1,
        explanation: "「病気を診ずして病人を診よ」は、患者全体の心身の状態を診察することの重要性を示しています。"
      },
      {
        id: 88,
        question: "1940年、神武天皇即位紀元2600年を記念して宮崎市に建設された塔は何ですか？",
        options: [
          "太陽の塔",
          "平和の塔",
          "通天閣",
          "宮崎県庁"
        ],
        correctAnswer: 1,
        explanation: "平和の塔は、神武天皇即位紀元2600年を記念して建設されました。"
      },
      {
        id: 89,
        question: "1960年代の新婚旅行ブームで人気を博した、青島、霧島、桜島を結ぶ観光ルートは何と呼ばれましたか？",
        options: [
          "ゴールデンルート",
          "プリンセス・ライン",
          "三島ルート",
          "神話街道"
        ],
        correctAnswer: 2,
        explanation: "三島ルートは、青島、霧島、桜島を結ぶ人気の観光ルートでした。"
      },
      {
        id: 90,
        question: "小村寿太郎がハーバード大学へ留学する際、どの藩の派遣留学生として選ばれましたか？",
        options: [
          "薩摩藩",
          "高鍋藩",
          "飫肥藩",
          "延岡藩"
        ],
        correctAnswer: 2,
        explanation: "小村寿太郎は、飫肥藩の派遣留学生としてハーバード大学へ留学しました。"
      }
    ]
  },
  {
    id: 10,
    title: "セット10: 受け継がれる伝統",
    category: "文化・伝統",
    questions: [
      {
        id: 91,
        question: "高千穂地方で毎年11月下旬から翌年2月にかけて、五穀豊穣を祈願して夜を徹して奉納される神楽を何と呼びますか？",
        options: [
          "高千穂神楽",
          "狭野神楽",
          "高千穂の夜神楽",
          "祓川神楽"
        ],
        correctAnswer: 2,
        explanation: "高千穂の夜神楽（たかちほのよかぐら）は、夜を徹して奉納される伝統的な神楽です。"
      },
      {
        id: 92,
        question: "高千穂の夜神楽の起源は、どの神話の出来事に由来するとされていますか？",
        options: [
          "天孫降臨",
          "海幸彦・山幸彦",
          "天岩戸神話",
          "神武東征"
        ],
        correctAnswer: 2,
        explanation: "高千穂の夜神楽の起源は、天岩戸神話に由来するとされています。"
      },
      {
        id: 93,
        question: "高千穂の夜神楽は、全部で何番の演目で構成されていますか？",
        options: [
          "十二番",
          "二十四番",
          "三十三番",
          "四十八番"
        ],
        correctAnswer: 2,
        explanation: "高千穂の夜神楽は、三十三番の演目で構成されています。"
      },
      {
        id: 94,
        question: "高千穂の夜神楽が国の重要無形民俗文化財に指定されたのはいつですか？",
        options: [
          "1958年（昭和33年）",
          "1968年（昭和43年）",
          "1978年（昭和53年）",
          "1988年（昭和63年）"
        ],
        correctAnswer: 2,
        explanation: "高千穂の夜神楽は、1978年（昭和53年）に国の重要無形民俗文化財に指定されました。"
      },
      {
        id: 95,
        question: "宮崎を代表する郷土料理「チキン南蛮」が発祥したとされる都市はどこですか？",
        options: [
          "宮崎市",
          "延岡市",
          "日南市",
          "都城市"
        ],
        correctAnswer: 1,
        explanation: "チキン南蛮は、延岡市で発祥したとされています。"
      },
      {
        id: 96,
        question: "タルタルソースをかけずに、甘酢ダレだけで味わうスタイルの元祖チキン南蛮を提供していることで知られる延岡市の店はどこですか？",
        options: [
          "おぐら",
          "グリル爛漫",
          "直ちゃん",
          "味のおぐらチェーン"
        ],
        correctAnswer: 2,
        explanation: "直ちゃんは、甘酢ダレだけのスタイルの元祖チキン南蛮を提供しています。"
      },
      {
        id: 97,
        question: "現在主流となっているタルタルソースをかけたチキン南蛮を考案したとされる洋食店は何ですか？",
        options: [
          "ロンドン",
          "直ちゃん",
          "おぐら",
          "味心"
        ],
        correctAnswer: 2,
        explanation: "おぐらが、タルタルソースをかけたチキン南蛮を考案したとされています。"
      },
      {
        id: 98,
        question: "焼いた魚のほぐし身と焼き味噌をすり鉢ですり、冷たいだし汁でのばして麦飯にかけて食べる、宮崎の夏の郷土料理は何ですか？",
        options: [
          "がね",
          "鶏の炭火焼",
          "冷や汁",
          "魚うどん"
        ],
        correctAnswer: 2,
        explanation: "冷や汁（ひやじる）は、宮崎の夏の代表的な郷土料理です。"
      },
      {
        id: 99,
        question: "冷や汁の起源について言及している鎌倉時代の書物は何ですか？",
        options: [
          "吾妻鏡",
          "平家物語",
          "鎌倉管領家記録",
          "方丈記"
        ],
        correctAnswer: 2,
        explanation: "鎌倉管領家記録に、冷や汁の起源について言及されています。"
      },
      {
        id: 100,
        question: "冷や汁が、かつてどのような人々の食事として定着していたと伝えられていますか？",
        options: [
          "藩主や上級武士",
          "商人や職人",
          "僧侶や神官",
          "農民や漁師"
        ],
        correctAnswer: 3,
        explanation: "冷や汁は、かつて農民や漁師の食事として定着していたと伝えられています。"
      }
    ]
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
